module.exports = __webpack_public_path__ + "pushover-logo.png";